import React from 'react';
import { Helmet } from 'react-helmet';
import bannerBg from '../assets/img/page-banner.jpg';
import AboutFeatured from '../components/AboutFeatured';
import Approch from '../components/Approch';
import Footer1 from '../components/Footer1';
import Header1 from '../components/Header1';
import PageBanner from '../components/PageBanner';
import Timeline from '../components/Timeline';

function About() {
    return (
        <>
            <Helmet>
                <title>Despre Noi - Work Express | Companie de Construcții și Renovări București</title>
                <meta name="description" content="Work Express este o companie dinamică și inovatoare, fondată în 2017, dedicată furnizării soluțiilor eficiente și moderne pentru construcții și renovări în București." />
                <meta name="keywords" content="despre work express, companie constructii bucuresti, echipa constructii, renovari profesionale, experienta constructii" />
                <meta property="og:title" content="Despre Work Express - Companie de Construcții bucurești" />
                <meta property="og:description" content="Echipă pasionată și orientată spre excelență, oferind rezultate de înaltă calitate din 2017." />
                <link rel="canonical" href="https://workexpress.ro/despre-noi" />
            </Helmet>
            <Header1 />
            <PageBanner bannerBg={bannerBg} currentPage="Despre Noi" heading="Despre Noi" />
            <AboutFeatured />
            <Approch />
            <Timeline />
            <Footer1 />
        </>
    );
}

export default About;
